import { createContext, useMemo } from 'react';

export type ModalContextState = {
  onClose?: () => void;
};

export const ModalContext = createContext<ModalContextState>({});

export const ModalContextProvider: React.FC<
  React.PropsWithChildren<ModalContextState>
> = ({ children, onClose }) => {
  const value = useMemo(() => ({ onClose }), [onClose]);

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
